import React, { FC } from 'react'
import capitalize from 'lodash/capitalize'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Typography } from 'transfix-ui/core'
import { ITrailerShipmentFragment } from 'apps/marketplace/pages/shippers/components/ShipperTrailers/graphql/TrailerShipmentFragment'
import { DropTrailerIcon } from 'transfix-icons'
import { DISPLAY } from 'constants/display'
import EmptyInfo from './EmptyInfo'

interface ILaneDisplayProps {
  firstPickup: ITrailerShipmentFragment['firstPickup'] | undefined
  lastDelivery: ITrailerShipmentFragment['lastDelivery'] | undefined
}

const LaneDisplay: FC<ILaneDisplayProps> = ({ firstPickup, lastDelivery }) => {
  if (firstPickup && lastDelivery) {
    return (
      <>
        {firstPickup.dropTrailer && <Tooltip trigger={<DropTrailerIcon />}>Drop</Tooltip>}
        <Typography variant='body1'>
          {capitalize(firstPickup.city || '')}, {firstPickup.stateCode || ''} {`${DISPLAY.empty} `}
          {capitalize(lastDelivery.city || '')}, {lastDelivery.stateCode || ''}
        </Typography>
        {lastDelivery.dropTrailer && <Tooltip trigger={<DropTrailerIcon />}>Drop</Tooltip>}
      </>
    )
  }

  return <EmptyInfo />
}

export default LaneDisplay
